import React, { useEffect, useState } from 'react'
import './SearchBoxPractice.scss'
import PropTypes from 'prop-types'

const SearchBox = ({ isError, onChange, disabled, placeholder = 'Search' }) => {
  const [searchText, setSearchText] = useState('')
  const [isFocus, setIsFocus] = useState(false)
  const [isContent, setIsContent] = useState(false)
  const [searchBoxClasses, setSearchBoxClasses] = useState('')

  useEffect(() => {
    let classes = 'searchbox-container-practice'
    if (isFocus && !isError) {
      classes = `${classes} searchbox-focus-practice`
    } else if (isError) {
      classes = `${classes} searchbox-error-practice`
    } else {
      classes = `${classes} searchbox-normal-practice`
    }
    if (disabled) {
      classes = `${classes} searchbox-bg-disabled-practice`
    } else {
      classes = `${classes} searchbox-bg-practice`
    }
    setSearchBoxClasses(classes)
  }, [isFocus, isError, disabled])

  const handleChangeSearch = (text) => {
    if (onChange) {
      onChange(text)
    }
    setIsContent(text !== '')
    setSearchText(text)
  }

  const handleCloseClick = () => {
    setIsContent(false)
    setSearchText('')
    onChange('')
  }

  return (
    <div className="searchbox-holder-practice">
      <div className={`searchbox-container-practice ${searchBoxClasses}`}>
        {!isContent && (
          <div className="search-icon-container-practice">
            <i className="fa-light fa-magnifying-glass" style={{ fontSize: '0.9em' }}></i>
          </div>
        )}

        <div className="input-container-practice">
          <input
            className="input-search-practice"
            disabled={disabled}
            onBlur={() => setIsFocus(false)}
            onChange={(e) => handleChangeSearch(e.target?.value)}
            onFocus={() => setIsFocus(true)}
            placeholder={placeholder}
            type="text"
            value={searchText}
          />
        </div>
        {isContent && (
          <div className="close-icon-container-practice">
            <i
              className="far fa-xmark"
              style={{ cursor: 'pointer' }}
              onClick={handleCloseClick}
            ></i>
          </div>
        )}
      </div>
    </div>
  )
}

SearchBox.propTypes = {
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
}

export default SearchBox
